import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import backgroundImage from './images/tourly-book-1440.png';
import { NamedLink } from '../../../../components';

import css from './SectionBnbsBook.module.css';

const SectionBnbsBook = props => {
  const { rootClassName, className } = props;

  const classes = clsx(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.wrapper}>
        <div className={css.title}>
          <FormattedMessage id="SectionBnbsBook.title" />
          <br />
        </div>
        <div className={css.text}>
          <FormattedMessage id="SectionBnbsBook.text" />
          <br />
        </div>

        <div>
          <div className={css.heroButtonWrapper}>
            <NamedLink name="AffiliateSignupPage" className={css.heroBnbsButton}>
              <FormattedMessage id="SectionBnbsBook.CTAButton" />
            </NamedLink>
          </div>
        </div>
      </div>
    </div>
  );
};

SectionBnbsBook.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionBnbsBook.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionBnbsBook;
